import React from 'react';
import FeatherIcon from "feather-icons-react";
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { CustomTooltip } from '../../consts';
import { UPDATE_INSIGHT_FAILED, UPDATE_INSIGHT_SET_SUCCESS, UPDATE_INSIGHT_UNSET_SUCCESS } from '../../helpers/messages';
import Utils from '../../utils';
import { IconButton } from '@mui/material';
import { useThemeMode } from '../../components/theme';

const SetAlertConfirmButton = ({ id, alertData, onSuccess }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();
    const { colours } = useThemeMode();

    const handleConfirm = async () => {
        try {
            setIsLoading(true)
            Utils.sendProgressBar(true);

            const companyDTO = await Utils.genericGet("getCompany", id);
            const company = companyDTO.data.getCompany;
            company.trackers = JSON.parse(company.trackers);

            for (const tracker of company.trackers) {
                if (tracker.name === alertData.name) {
                    tracker.alert = !alertData.alert;
                    break;
                }
            }
            await Utils.genericMutation("updateCompany", {
                id: id,
                trackers: JSON.stringify(company.trackers)
            });
            setOpen(false);
            setIsLoading(false);
            showSnackbar(alertData.alert ? UPDATE_INSIGHT_UNSET_SUCCESS : UPDATE_INSIGHT_SET_SUCCESS);
            onSuccess();
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(UPDATE_INSIGHT_FAILED, "error");
        }
    };

    const renderConfirm = () => {
        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={setOpen}
            onConfirm={handleConfirm}
            title="Please Confirm"
            okText={"Okay"}
            message={`Are you sure you want to do this action?`}
        />)
    }

    const handleClick = (e) => {
        setOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={alertData.alert ? "Unset Alert" : "Set Alert"}>
                <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-label={alertData.alert ? "Unset Alert" : "Set Alert"}
                    sx={{ marginLeft: "-.25rem" }}
                    color={alertData.alert ? "success" : "info"}
                >
                    {alertData.alert ? (
                        <FeatherIcon icon="bell" />
                    ) : (
                        <FeatherIcon icon="bell-off"  />
                    )}
                </IconButton>
            </CustomTooltip>
        </>
    )
}

export default SetAlertConfirmButton